import styled from 'styled-components';

const AccessibleFocusButton = styled.button.attrs({ type: 'button' })`
    appearance: none;
    background: transparent;
    border: 0;
    padding: 0;
    margin: 0;
    font: inherit;
    line-height: inherit;
    color: inherit;
    cursor: pointer;

    &:focus {
        outline: 2px solid currentColor;
        outline-offset: 2px;
    }
`;

export default AccessibleFocusButton;
